import Vue from 'vue';
import Router from 'vue-router';
import PodoCore from '@/plugins/podolib';
import consola from 'consola';

// Routes
import Home from '@/pages/Home.vue';
import Patients from '@/pages/patients/PagePatients.vue';
import Patient from '@/pages/patients/PagePatient.vue';
import PageAnalysis from '@/pages/PageAnalysis.vue';
import SignIn from '@/pages/auth/PageAuthSignIn.vue';
import PageAuthMfa from '@/pages/auth/PageAuthMfa.vue';

Vue.use(Router);

const logger = consola.withScope('router');

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // region Standard
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        layout: 'dashboard',
      },
    },
    {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "account" */ './pages/PageAccount.vue'),
      meta: {
        layout: 'dashboard',
      },
    },
    {
      path: '/patients',
      name: 'patients',
      component: Patients,
      meta: {
        layout: 'dashboard',
      },
    },
    {
      path: '/patient/:id',
      name: 'patient',
      component: Patient,
      meta: {
        layout: 'dashboard',
      },
      children: [
        {
          path: 'evolution',
          name: 'patient-evolution',
          component: () =>
            import(/* webpackChunkName: "patient-evolution" */ './pages/patients/PagePatientEvolution.vue'),
        },
        {
          path: 'comparison',
          name: 'patient-comparison',
          component: () =>
            import(/* webpackChunkName: "patient-comparison" */ './pages/patients/PagePatientResultsComparison.vue'),
        },
        {
          path: 'result/:acquisitionId',
          name: 'patient-result',
          component: () => import(/* webpackChunkName: "patient-result" */ './pages/patients/PagePatientResults.vue'),
        } /*,
        {
          path: 'analysis',
          name: 'patient-analysis',
          component: () =>
            import(/!* webpackChunkName: "patient-analysis" *!/ './pages/patients/acquisition/PagePatientAnalysis.vue')
          /!*children: [
            {
              path: 'mode',
              name: 'patient-analysis-mode',
              component: () =>
                import(
                  /!* webpackChunkName: "patient-acquisition-mode" *!/ './pages/patients/acquisition/PagePatientAcquisitionMode.vue'
                ),
              meta: {
                layout: 'dashboard'
              }
            },
            {
              path: 'progress',
              name: 'patient-analysis-progress',
              component: () =>
                import(
                  /!* webpackChunkName: "patient-acquisition-progress" *!/ './pages/patients/acquisition/PagePatientAcquisitionProgress.vue'
                ),
              meta: {
                layout: 'dashboard'
              }
            }
          ]*!/
        }*/,
      ],
    },
    {
      path: '/analysis',
      name: 'analysis',
      component: PageAnalysis,
      meta: {
        layout: 'analysis',
      },
    },
    {
      path: '/equipments',
      name: 'equipments',
      component: () => import(/* webpackChunkName: "equipments" */ './pages/PageEquipments.vue'),
      meta: {
        layout: 'dashboard',
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './pages/Settings.vue'),
      meta: {
        layout: 'dashboard',
      },
    },
    /*{
      path: '/subscription',
      name: 'subscription',
      component: () =>
        import(
          /!* webpackChunkName: "subscription" *!/ './pages/Subscription.vue'
        ),
      meta: {
        layout: 'dashboard'
      }
    },*/
    /*{
      path: '/about',
      name: 'about',
      component: () => import(/!* webpackChunkName: "about" *!/ './pages/About.vue'),
      meta: {
        layout: 'analysis'
      }
    },*/
    // endregion

    // region Authentication
    {
      path: '/auth/sign-in',
      name: 'auth-sign-in',
      component: SignIn,
      meta: {
        layout: 'auth',
      },
    },
    {
      path: '/auth/mfa',
      name: 'auth-mfa',
      component: PageAuthMfa,
      meta: {
        layout: 'auth',
      },
    },
    {
      path: '/auth/sign-up',
      name: 'auth-sign-up',
      component: () => import('@/pages/auth/PageAuthSignUp.vue'),
      meta: {
        layout: 'auth-trial',
      },
    },
    {
      path: '/auth/confirm-sign-up',
      name: 'auth-confirm-sign-up',
      component: () => import('@/pages/auth/PageAuthConfirmSignUp.vue'),
      meta: {
        layout: 'auth-trial',
      },
    },
    {
      path: '/auth/forgot-password',
      name: 'auth-forgot-password',
      component: () => import(/* webpackChunkName: "auth-forgot-password" */ './pages/auth/PageAuthForgotPassword.vue'),
      meta: {
        layout: 'auth',
      },
    },
    {
      path: '/auth/reset-password',
      name: 'auth-reset-password',
      component: () => import(/* webpackChunkName: "auth-reset-password" */ './pages/auth/PageAuthResetPassword.vue'),
      meta: {
        layout: 'auth',
      },
    },
    {
      path: '/auth/create-doctor-profile',
      name: 'auth-create-doctor-profile',
      component: () =>
        import(/* webpackChunkName: "auth-create-doctor-profile" */ './pages/auth/PageAuthCreateDoctorProfile.vue'),
      meta: {
        layout: 'auth-trial',
      },
    },
    // endregion
    {
      path: '/404-not-found',
      name: 'not-found',
      component: () => import(/* webpackChunkName: "not-found" */ './pages/NotFound.vue'),
    },
    {
      path: '/401-not-authorized',
      name: 'not-authorized',
      component: () => import(/* webpackChunkName: "not-found" */ './pages/NotAuthorized.vue'),
    },
    { path: '*', redirect: '/404-not-found' },
  ],
});

/*router.beforeResolve(async (to, from, next) => {
  return PodoCore.acl!.middleware(to, from, next);
});*/

router.beforeEach((to, from, next) => {
  if (from.name) {
    logger.log(`🛫 Leave "${from.name}" and go to "${to.name}"`);
  } else {
    logger.log(`🛫 Go to "${to.name}"`);
  }
  PodoCore.bus!.emitDebug('router:leave');
  // Podolib middleware
  return PodoCore.acl!.middleware(to, from, next);
});

router.afterEach((to, from) => {
  let log = `🏁 Enter to "${to.name}"`;
  if (from.name) log += ` from "${from.name}"`;
  logger.log(log);
  setTimeout(() => {
    if (to.name === 'auth-sign-in') {
      PodoCore.bus!.emit('app:reset');
    }

    PodoCore.bus!.emitDebug('router:enter');
    PodoCore.analytics!.actions.page(to.name!, {
      referrer: from.path,
    });
  });
});

export default router;
